// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".worker-page_header-row{display:flex;align-items:center;justify-content:space-between}.worker-page_content{padding-top:48px;padding-bottom:48px}@media(min-width:640px){.worker-page_content{padding-top:calc(6vw + 9.6px);padding-bottom:calc(6vw + 9.6px)}}@media(min-width:1440px){.worker-page_content{padding-top:96px;padding-bottom:96px}}.worker-page_content-col{margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
